import { call } from '@advanza/api'
import { Button } from '@advanza/ui'
import InputField from '@trustoo/components/input/InputField'
import { useToast } from 'components/misc/Toaster'
import { useState } from 'react'

const DEFAULT_LAST_DAYS = 14
const MIN_LAST_DAYS = 1
const MAX_LAST_DAYS = 60

const normalizeLastDays = (lastDays: number) =>
    Math.min(MAX_LAST_DAYS, Math.max(MIN_LAST_DAYS, lastDays))

function schedulingExportErrorMessage(err: unknown): string {
    if (err instanceof Error) {
        return err.message
    }
    if (typeof err === 'object' && err !== null && 'error' in err) {
        return String((err as { error: unknown }).error)
    }
    return String(err)
}

const ExportPartialMatchesButton = () => {
    const { addToast } = useToast()
    const [lastDays, setLastDays] = useState(DEFAULT_LAST_DAYS)
    const [isLoading, setIsLoading] = useState(false)

    const handleExport = async () => {
        setIsLoading(true)

        try {
            await call('office/misc/schedule-partial-matches-export', {
                method: 'POST',
                payload: { lastDays },
            })

            addToast({
                msg: 'Export task has been scheduled. You will receive the file via Slack when it is ready.',
                green: true,
                icon: 'check_circle',
            })
        } catch (err) {
            addToast({
                msg: 'Error scheduling export: ' + schedulingExportErrorMessage(err),
                red: true,
            })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="space-y-4">
            <p className="text-sm text-text-secondary-700">
                Exports `partial_matches_debug` system logs from the last number of days and sends
                the CSV to Slack.
            </p>
            <div className="flex flex-wrap items-end gap-3">
                <InputField
                    legend="Last X days"
                    type="number"
                    min={MIN_LAST_DAYS}
                    max={MAX_LAST_DAYS}
                    step={1}
                    value={lastDays}
                    onChange={(e) => {
                        const inputLastDays = e.target.valueAsNumber
                        setLastDays(
                            normalizeLastDays(
                                Number.isNaN(inputLastDays) ? DEFAULT_LAST_DAYS : inputLastDays,
                            ),
                        )
                    }}
                    labelClassName="!h-10"
                />
                <Button appearance="primary" onClick={handleExport} disabled={isLoading}>
                    {isLoading ? 'Scheduling...' : 'Export Partial Matches'}
                </Button>
            </div>
        </div>
    )
}

export default ExportPartialMatchesButton
